import { STATES } from '../../../../constants';

const PAGE_TITLE = 'Confirm Details';

export default function Config($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.STEP_UPDATE_ACCOUNTS_CONFIRM, {
    url: '/confirm',
    views: {
      '@': {
        template: `<upd-confirm-move></upd-confirm-move>`,
      },
    },
    scrollTop: true,
    title: PAGE_TITLE,
    analytics: {
      page: 'Update Accounts Confirm Details',
    },
    data: {
      permissions: 'signedIn && !moveConfirmed',
      successState: STATES.STEP_UPDATE_ACCOUNTS,
    },
  });
}
